import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import BasetaoSpreadsheetGuide from "../pages/article/guide/page";
import BasetaoReview from "../pages/article/review/page";
import ArticleDetail from "../pages/article/detail/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/basetao-spreadsheet-guide",
    element: <BasetaoSpreadsheetGuide />,
  },
  {
    path: "/basetao-review",
    element: <BasetaoReview />,
  },
  {
    path: "/article/:slug",
    element: <ArticleDetail />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;